var map = {
	"./arrow-right.png": 3057,
	"./arrow_down.png": 8625,
	"./bell.png": 6742,
	"./bookmark.png": 8133,
	"./bookmark.svg": 7447,
	"./bookmark_fill.svg": 2664,
	"./download.png": 445,
	"./heart.svg": 8371,
	"./heart_red.svg": 1794,
	"./play.png": 8379,
	"./profile.png": 3579,
	"./search.png": 8143,
	"./share.png": 8228,
	"./star.png": 4109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2168;